import _ from 'lodash'

class RecordFilterService {
  constructor($analytics) {
    this.$analytics = $analytics
    this.filters = {
      'default': {
        docFilter  : ['All Documents'],
        leaseFilter: ['All Lease Classifications']
      }, 
      'current': {
        docFilter  : 'All Documents',
        leaseFilter: 'All Lease Classifications'
      }
    }
  }

  get defaultDocFilter() {
    return this.filters.default.docFilter
  }

  get defaultLeaseFilter() {
    return this.filters.default.leaseFilter
  }

  get currentLeaseFilter() {
    return this.filters.current.leaseFilter
  }

  get currentDocFilter() {
    return this.filters.current.docFilter
  }

  set currentDocFilter(filterOption) {
    this.filters.current.docFilter = filterOption
  }

  set currentLeaseFilter(filterOption) {
    this.filters.current.leaseFilter = filterOption
  }

  get allLeasesVisible() {
    return this.currentLeaseFilter === this.defaultLeaseFilter[0]
  }

  get allDocsVisible() {
    return this.currentDocFilter === this.defaultDocFilter[0]
  }

  rowMatchesCurrentLeaseFilter(row) {
    return row.entity.summary.classification === this.currentLeaseFilter
  }

  rowMatchesCurrentDocFilter(row) {
    return row.entity.docType === this.currentDocFilter
  }

  toSelectedDocs(row) {
     return (this.allDocsVisible || this.rowMatchesCurrentDocFilter(row))
  }

  toSelectedLeases(row) {
    if (row.entity.docType === 'Lease') {
      return (this.allLeasesVisible || this.rowMatchesCurrentLeaseFilter(row))
    }
    return true
  }

  setAllToInvisible(row) {
    row.visible = false
    return row
  }

  setRemainderToVisible(row) {
    row.visible = true
    return row
  }

  onlyVisibleRows(renderableRows) {
    return _(renderableRows)
            .map(this.setAllToInvisible.bind(this))
            .filter(this.toSelectedDocs.bind(this))
            .filter(this.toSelectedLeases.bind(this))
            .map(this.setRemainderToVisible.bind(this))
            .value()
  }
}

RecordFilterService.$inject = ['$analytics']

export default RecordFilterService
